<!-- <sm-title-bar [pageTitle]="mn + ' wallet money'" [back]="true" [headerCustomTemplate]="addButton">
  <ng-template #addButton>
    <div class="d-flex search-field">
      <div class="add_brtnfh">
        <button mat-icon-button color="accent" (click)="openwalletmoney()">
          <mat-icon class="material-icons-round" [inline]="true">add</mat-icon>
        </button>
      </div>
    </div>
  </ng-template>
</sm-title-bar> -->

<div class="page-title-bar mb-4" style="align-items: center;">
 <div class="customer_flexc" style="align-items: center;">
  <div class="title d-flex" style="align-items: center;">
    <div class="custgomner_wallet">
    <button mat-icon-button class="me-3" (click)="backButton()">
      <mat-icon class="material-icons-round">arrow_back</mat-icon>
      </button>
     </div>
    <div>
      <div class="rt_tht">
      <h1>{{mn}} Wallet money</h1>
    </div>
    </div>
  </div>
  
  <div class="add_brtnfh">
<button
  mat-icon-button
  color="accent"
  (click)="openwalletmoney()"
  >
  <mat-icon class="material-icons-round" [inline]="true">add</mat-icon>
</button>

<!-- Menu -->
<mat-menu #walletMenu="matMenu" class="wallet-menu">
  <button mat-menu-item >
    <mat-icon class="material-icons-outlined">account_balance_wallet</mat-icon>
    <span>Add Wallet Money</span>
  </button>
<!-- (click)="openPointConversion()" -->
  <!-- <button mat-menu-item (click)="openPointConversion()" >
    <mat-icon class="material-icons-outlined">ballot</mat-icon>
    <span>Point Conversion</span>
  </button> -->
</mat-menu>


  </div>
</div>
</div>



<!-- Summary Section -->
<div class="bradcamp_inventory" style="margin-top: -15px" *ngIf="!loader">
  <div class="row">
    <div class="over_sectionkl">
      <div class="overall_count_s">
        <p>Total</p>
        <h3>
          {{ walletData.currency_symbol }}{{ walletData.total.toFixed(2) }}
        </h3>
      </div>
      <div class="overall_count_s" style="border-right: none !important">
        <p>This month</p>
        <h3>
          {{ walletData.currency_symbol }}{{ walletData.monthly.toFixed(2) }}
        </h3>
      </div>
    </div>
  </div>
</div>

<!-- <div class="date-range-form">
                  <div class="nw_all">
                  <mat-form-field appearance="outline">
                    <mat-label>From Date</mat-label>
                    <input matInput [matDatepicker]="fromDatePicker" name="fromDate"  readonly>
                    <mat-datepicker-toggle matSuffix [for]="fromDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #fromDatePicker></mat-datepicker>
                  </mat-form-field>
               </div>
               <div class="nw_all">
                  <mat-form-field appearance="outline">
                    <mat-label>To Date</mat-label>
                    <input matInput [matDatepicker]="toDatePicker" name="toDate"  readonly>
                    <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #toDatePicker></mat-datepicker>
                  </mat-form-field>
                  </div>
            </div> -->
<!-- <div class="search_pag">
              <button mat-flat-button color="primary" type="submit">Submit</button>
          </div>
           <div class="service_create_sd">
         <div class="search-bar-custom">
            <mat-form-field appearance="outline">
               <mat-label>Search</mat-label>
               <mat-icon matPrefix>search</mat-icon>
               <input matInput placeholder="Search" />
            </mat-form-field>
         </div>
       </div> -->

<!-- Expense Cards -->
<div class="expenjkad" *ngIf="walletTransactionData.length > 0">
  <div class="row">
    <div class="col-sm-4" *ngFor="let item of walletTransactionData">
      <mat-card>
        <div class="package-card">
          <div class="package-header">
            <div class="package-price" *ngIf="item.amount">
              {{ item.currency_symbol }}{{ item.amount.toFixed(2) }}
            </div>
            <div class="package-price" *ngIf="!item.amount">
              ---
            </div>
            <button mat-icon-button [matMenuTriggerFor]="packageMenu1">
              <mat-icon>more_vert</mat-icon>
            </button>
          </div>
          <div class="package-title">{{ item.notes }}</div>
          <div class="package-date" style="margin-bottom: 5px;">
            <span class="status_active" *ngIf="item.transaction_type == 1 && item.status != 2"></span>
            <span class="status_refunded" *ngIf="item.transaction_type == 1 && item.status == 2"></span>
            <span class="status_inactive" *ngIf="item.transaction_type == 2"></span>
            <span class="main_activert">{{
              item.t_type
            }}</span>
          </div>
          <div class="package-date">
            <span class="main_activert" style="padding-left: 0px;">{{
              item.duty_date | date : "MMM d, y, h:mm a" : "UTC"
            }}</span>
          </div>
          <mat-menu #packageMenu1="matMenu">
            <button
              (click)="setRefundStatus(item, 2)"
              mat-menu-item
              *ngIf="item.status == 1 && item.transaction_type == 1"
            >
              <mat-icon class="material-icons-outlined">check_box</mat-icon>
              <span>Mark as refunded</span>
            </button>
            <button
              (click)="setRefundStatus(item, 1)"
              mat-menu-item
              *ngIf="item.status == 2 && item.transaction_type == 1"
            >
              <mat-icon class="material-icons-outlined">undo</mat-icon>
              <span>Revert refund</span>
            </button>
            <button
              (click)="deleteWalletTransaction(item)"
              mat-menu-item
              *ngIf="item.status == 1"
              [disabled]="item.transaction_entry_type != 5"
            >
              <mat-icon class="material-icons-outlined">delete</mat-icon>
              <span>Delete</span>
            </button>
          </mat-menu>
        </div>
      </mat-card>
    </div>
  </div>
</div>

 <div class="" *ngIf="walletTransactionData.length == 0 && !loader">
    <div class="row">
      <div class="col-sm-12">
        <div class="svg_cont">
          <div class="booking_img_placeholder">
            <img src="../../../../assets/images/wallet_money_placeholder.png"/>
          </div>
          <div class="h2_cont">
            <!-- <h2>
              It seems like your wallet is empty. <br />
              Go for appoitments and get the best deal in the market.
            </h2> -->

            <h2>There's no transaction happened in this wallet. Current balance and transactions will show here once it's started.</h2>
          </div>
        </div>
      </div>
    </div>
  </div>